<template>
    <div>
        <v-card>
           <v-card-title class="subtitle-1 mt-2">{{$t('labels.CLI_BrokerDetails')}}</v-card-title>
           <v-card-text>
               <v-row col="12">
                   <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_BrokerName')}}</span></v-row>
                       <v-row no-gutters><span>{{brokerName}}</span></v-row>
                   </v-col>
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_Brand')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{brokerDetail.Brand}}</span> </v-row>
                   </v-col>
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_Brokerage')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{brokerDetail.Name}}</span> </v-row>
                   </v-col>
                    <v-col lg="3" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_BrokerageType')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{brokerDetail.BrokerageType}}</span> </v-row>
                   </v-col>
               </v-row>               
           </v-card-text>
       </v-card>
    </div>
</template>
<script>
export default {
    props:["brokerDetail"],
    computed:{
       brokerName:function(){
          if(!this.brokerDetail){
             return "";
          }
          return this.brokerDetail.BrokerFirstName + " " + this.brokerDetail.BrokerLastName
       }
  }
}
</script>
<style scoped>
</style>